<template>
  <div>
    <div slot="title">
      <h2>Becarios</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12"><hr /></div>
        </div>
        <div class="row">
          <div class="col-12">
            <table
              class="table table-striped table-light table-hover"
              id="tabla_Becarios"
              data-search="true"
              data-toggle="table"
              data-pagination="true"
              data-show-export="true"
            >
              <thead class="thead-dark">
                <tr>
                  <th data-field="PersonaId" data-sortable="true">
                    Persona ID
                  </th>
                  <th data-field="Nombre" data-sortable="true">
                    Nombre
                  </th>
                  <th data-field="ApellidoPaterno" data-sortable="true">
                    Apellido Paterno
                  </th>
                  <th data-field="ApellidoMaterno" data-sortable="true">
                    Apellido Materno
                  </th>
                  <!-- :data-detail-formatter="this.BecarioTrabajadorFormato()" -->
                  <th
                    data-field="TipoDepartamentoArea.Area.Nombre"
                    data-sortable="true"
                  >
                    Área
                  </th>
                  <th
                    :data-formatter="this.BecarioFormato()"
                    data-events="operateEvents"
                    data-halign="center"
                    data-align="center"
                  >
                    Acciones
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import catalogos from "@/../static/js/catalogos";
import comun from "@/../static/js/comun";
import enumeraciones from "@/../static/js/enumeraciones";
import api from "@/../static/js/api";
import axios from "axios";
import Vue from "vue";
import store from "@/store/index";

export default {
  data() {
    return {
      enumeraciones,
      becarios: null
    };
  },
  components: {},
  methods: {
    BecarioFormato: function operateFormatter(value, row, index) {
      return [
        '<a class="editar-becario" href="javascript:void(0)" title="Editar becario">',
        '<i class="fas fa-user-edit"></i>',
        "</a>"
      ].join("");
    },
    CargarBecariosYTrabajadores() {
      comun.SeEstaCargandoInformacion(true);
      let peticion = {
        ConActivos: "true"
      };
      axios
        .post(
          api.conexion + api.SIAP.funcion.GetBecarios,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          if (response.data.SiHayError == false) {
            console.log(response.data.Becarios);
            this.becarios = response.data.Becarios;
            this.LlenarTablaDeBecarios();
          } else {
            console.log(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error(e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
    NuevoBecario() {},
    LlenarTablaDeBecarios() {
      var $tablaBecarios = $("#tabla_Becarios");
      $tablaBecarios.bootstrapTable({
        data: this.becarios
      });
      $tablaBecarios.bootstrapTable("load", this.becarios);
    },
    ///Inicia los eventos que tendran los iconos de las acciones
    IniciarEventosDeLasAcciones() {
      // (e, value, row, index)
      window.operateEvents = {
        "click .editar-becario": (e,val,row,index) => {          
          this.editarUsuario(row.CURP);
        }
      };
    },    
    editarUsuario: function(curpUsuario) {
      //Redirigeal usuario a la pantalla de editarusuario mandando como parametro el id de persona a editar
      this.$router.push({
        name: "AltaDeUsuario",
        params: { propCurp: curpUsuario }
      });
    }
  },

  mounted: function() {
    this.CargarBecariosYTrabajadores();
    this.IniciarEventosDeLasAcciones();
  }
};
</script>

<style scoped>
/* Se requiere para que el color del texto de la tabla sea negro */
table {
  color: #343a40 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Becarios/Becarios.vue